/* Ideas landing pages (Shai's redesign part 2, 2026-10-23): PostHog events for the hourly read.
   landing_viewed {page} once per view; landing_cta_tapped {page, place: hero | card | idea | final, product, href, target}.
   target (since 2026-10-27): studio = the Studio's first screen (hero, final), group = the group setup (cards, ideas).
   window.mvTrack (snippets/posthog.liquid) queues until PostHog is ready, and forwards to Meta. */
(function () {
  var root = document.querySelector('[data-mvi-page]');
  if (!root) return;
  var page = root.getAttribute('data-mvi-page');
  var track = function (name, props, opts) { try { if (window.mvTrack) window.mvTrack(name, props, opts); } catch (e) {} };
  track('landing_viewed', { page: page });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-mvi-cta]');
    if (!a) return;
    track('landing_cta_tapped', { page: page, place: a.getAttribute('data-mvi-cta'), product: a.getAttribute('data-mvi-product') || '', href: a.getAttribute('href'), target: a.getAttribute('data-mvi-target') || 'group' }, { transport: 'sendBeacon' });
  });
})();
